import React from "react";
import {
  WorkflowConditionOperator,
  WorkflowConditionType,
} from "../../../../types";
import StalledStatusTriggerEditor from "./StalledStatusTriggerEditor";
import { TriggerEditorProps } from "./types";

type TriggerEditorKey = `${WorkflowConditionType}:${WorkflowConditionOperator}`;

type TriggerEditorComponent = React.ComponentType<TriggerEditorProps>;

const triggerEditorRepository: Partial<
  Record<TriggerEditorKey, TriggerEditorComponent>
> = {
  "status_id:does not change": StalledStatusTriggerEditor,
};

/**
 * Returns the custom editor registered for a trigger type and operator.
 */
export const getTriggerEditor = (
  type: WorkflowConditionType,
  operator: WorkflowConditionOperator,
): TriggerEditorComponent | undefined =>
  triggerEditorRepository[`${type}:${operator}`];
